import { useStore } from "stores/utils/use-store"

export const useFileUpload = () => {
  const {
    dataStore: {
      filesStore: { isLoading },
      filesStore,
    },
  } = useStore()

  const uploadFile = async(file: File) => {
    const formData = new FormData()
    formData.append("file", file)
    const url = await filesStore.uploadImageAndGetUrl(formData)

    return url
  }

  return {
    isLoading,
    uploadFile,
  }
}
